import { LegendModel } from '../../models/legend.model'

export const speedProfileLegend: LegendModel = {
  type: 'static',
  items: [
    {
      description: '>0',
      value: 'speed-profile-0', // near white
    },
    {
      description: '>20',
      value: 'speed-profile-20',
    },
    {
      description: '>40',
      value: 'speed-profile-40',
    },
    {
      description: '>60',
      value: 'speed-profile-60',
    },
    {
      description: '>90',
      value: 'speed-profile-90',
    },
    {
      description: '>120',
      value: 'speed-profile-120',
    },
  ],
}
